import { atom } from 'jotai';

export const scrollBarWidthAtom = atom(0);
